<template>
    <div class="team pa-3">
        <!-- List of researcher cards -->
        <h3 class="heading info--text my-3">Researcher List</h3>
        <v-divider></v-divider>
        <v-container fluid>
            <v-row>
                <v-col md="4" sm="6" cols="12" v-for="researcher in sorted_all_researcher_basic_info" :key="researcher.email">
                    <v-card
                        class="mx-auto"
                        color="grey lighten-4"
                    >
                        <v-container fluid>
                            <v-row class="">
                                <v-col cols="12">
                                    <v-row no-gutters justify="start" align="center">
                                        <v-col cols="7" class="">
                                            <div class="body-1"> {{researcher.name[1]}} {{researcher.name[0]}}</div>
                                            <div class="body-2">{{researcher.email}}</div>
                                            <div class="body-2">{{researcher.status?researcher.status:'Bronze'}}</div>
                                        </v-col>
                                        <v-col cols="5">
                                            <v-row no-gutters justify="center">
                                                <v-col cols="8" class="">
                                                    <div v-if="!cpcalculateSalaryPerResearcher(all_researcher_completed_tickets, researcher.email, researcher.status?researcher.status:'Bronze')" class="body-1 font-italic font-weight-light">
                                                    ¥ 0
                                                    </div>
                                                    <div v-if="cpcalculateSalaryPerResearcher(all_researcher_completed_tickets, researcher.email,researcher.status?researcher.status:'Bronze')" class="body-1 font-italic font-weight-light">
                                                    ¥ {{cpcalculateSalaryPerResearcher(all_researcher_completed_tickets, researcher.email,researcher.status?researcher.status:'Bronze')}}
                                                    </div>
                                                    <div class="caption">
                                                    this month
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="">
                                <v-col cols="12">
                                    <div class="body-2 font-weight-bold">
                                        Specialities:
                                    </div>
                                    <span class="body-2 font-italic font-weight-light ml-5" v-for="speciality in researcher.expertises" :key="speciality">
                                        {{speciality}}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row class="">
                                <v-col cols="6">
                                    <div class="body-2 font-weight-bold">
                                        Salary last month:
                                    </div>
                                    <div v-if="!cpcalculateSalaryPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email,researcher.status?researcher.status:'Bronze')" class="body-1 font-italic font-weight-light">
                                        ¥ 0
                                    </div>
                                    <div v-if="cpcalculateSalaryPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email,researcher.status?researcher.status:'Bronze')" class="body-1 font-italic font-weight-light">
                                        ¥ {{cpcalculateSalaryPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email,researcher.status?researcher.status:'Bronze')}}
                                    </div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="body-2 font-weight-bold">
                                        先月:
                                    </div>
                                    <div v-if="!cpcalculateNumberOfCompletedPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email)" class="body-1 font-italic font-weight-light">
                                        0件
                                    </div>
                                    <div v-if="cpcalculateNumberOfCompletedPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email)" class="body-1 font-italic font-weight-light">
                                        {{cpcalculateNumberOfCompletedPerResearcher(all_researcher_completed_tickets_previousMonth, researcher.email)}}件
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <div class="caption font-weight-bold">
                                        Maximum Commitment:
                                    </div>
                                    <div class="body-2 font-italic font-weight-light">
                                        {{researcher.max_commit}}
                                    </div>
                                </v-col>
                                <v-col cols="6">
                                    <div class="caption font-weight-bold">
                                        Minimum Commitment:
                                    </div>
                                    <div class="body-2 font-italic font-weight-light">
                                        {{researcher.min_commit}}
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-card-actions class="">
                            <h6>対応状況 / Ticket Status</h6>
                            <v-spacer></v-spacer>
                            <v-btn
                                icon
                                @click="show = !show"
                            >
                                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                            </v-btn>
                        </v-card-actions>
                        <v-expand-transition>
                            <div v-show="show">
                                <v-divider></v-divider>
                                <v-card-text>
                                    <div>対応中 / Working:</div>
                                    <span class="ml-1" v-for="(ticket,index) in $options.filters.ticketIdGroupedByEmail(all_researcher_editing_tickets, researcher.email)" :key="index">
                                        {{ticket.ticketId}}
                                    </span>
                                </v-card-text>
                                <v-card-text>
                                    <div>納品済み / Completed:</div>
                                    <span class="ml-1" v-for="(ticket,index) in $options.filters.ticketIdGroupedByEmail(all_researcher_completed_tickets, researcher.email)" :key="index">
                                        {{ticket.ticketId}}
                                    </span>
                                </v-card-text>
                                <v-card-text>
                                    <div>先月案件 / Last Month:</div>
                                    <span class="ml-1" v-for="(ticket,index) in $options.filters.ticketIdGroupedByEmail(all_researcher_completed_tickets_previousMonth, researcher.email)" :key="index">
                                        {{ticket.ticketId}}-¥ {{ticket.price}}
                                    </span>
                                </v-card-text>
                            </div>
                        </v-expand-transition>
                    </v-card>
                </v-col>
            </v-row>
            <!-- <p v-for="el in all_researcher_completed_tickets_previousMonth" :key="el.ticketId">
                {{el.price}}
            </p> -->
        </v-container>
        <!-- <div v-for="(item,index) in jacquesData" :key="index">
            {{item}}
        </div> -->
    </div>
</template>

<script>
/* eslint-disable no-console */
import {db} from '@/fb'
export default {
    name: 'researchers',
    components:{},
    data(){
        return {
            show: false,

            all_researcher_basic_info:[],
            // all_researcher_assigned_tickets:[],
            all_researcher_editing_tickets:[],
            all_researcher_completed_tickets:[],
            all_researcher_completed_tickets_previousMonth:[],
            all_researcher_salary:[],

            jacquesData:[],

            date:new Date(),
        }
    },
    computed:{
        salaryWithEnglish(){
            if(this.englishOrNot){
                var salaryItemsEnglish = this.salaryItems.map(salary=>{
                    return salary+500
                })
                return salaryItemsEnglish
            }else{
                return this.salaryItems
            }
        },
        sorted_all_researcher_basic_info(){
            return this.all_researcher_basic_info.slice().sort((a,b)=> a.id < b.id ? -1:1)
        },
        // open_tickets_id(){
        //     return this.$store.getters.open_tickets_id
        // },
        // all_researcher_emails(){
        //     var allResearchEmails = this.all_researcher_basic_info.map(research=>{
        //         return research.email
        //     })
        //     return allResearchEmails
        // },
        all_researcher_names_emails(){
            var allResearchNames = this.all_researcher_basic_info.map(research=>{
                return [research.name,research.email]
            })
            return allResearchNames
        },
        all_researcher_emails(){
            var allResearchEmails = this.selectedResearchers.map(researcher=>{
                return researcher[1]
            })
            return allResearchEmails
        },
        all_researcher_names(){
            var allResearchNames = this.selectedResearchers.map(researcher=>{
                return researcher[0][0]+' '+researcher[0][1]
            })
            return allResearchNames
        },
        cpcalculateSalaryPerResearcher: function(){
            return function(arr,researcherEmail,rank){
                let one_researcher_tickets = arr.filter(ticket=>ticket.researcherEmail==researcherEmail)
                let initialValue=0
                if(one_researcher_tickets.length!==0){
                    let sum = one_researcher_tickets.reduce((acc,cur)=>{
                        return acc+parseInt(cur.price)
                    },initialValue)
                    if(rank == 'Gold'){
                        return sum*1.2
                    }else{
                        return sum
                    }
                    
                }else{
                    return null
                }
            }
        },
        cpcalculateNumberOfCompletedPerResearcher: function(){
            return function(arr,researcherEmail){
                let one_researcher_tickets = arr.filter(ticket=>ticket.researcherEmail==researcherEmail)
                return one_researcher_tickets.length
            }
        }
    },
    methods:{

    },
    filters:{
        ticketIdGroupedByEmail(arr,researcherEmail){
            let one_researcher_tickets = arr.filter(ticket=>ticket.researcherEmail==researcherEmail)
            return one_researcher_tickets
        },
    },
    // created(){
    //     let ref = db.collection('ticket_completed').where('hand_in_month','==','9/2020')
    //     ref.get().then(snap=>{
    //         snap.forEach(doc=>{
    //             this.jacquesData.push(doc.data().ticket_number)
    //         })
    //     })
    // },
    mounted(){
        var self = this;
        const monthNumber = String(this.date.getMonth()+1)
        const previousMonthNumber = this.date.getMonth() == 0? "12": String(this.date.getMonth());
        const previousYearNumber = this.date.getMonth() == 0? String(this.date.getFullYear()-1):String(this.date.getFullYear());
        let currentMonthYear = monthNumber+'/'+String(this.date.getFullYear());
        let previousMonthYear = previousMonthNumber+'/'+previousYearNumber;
        let ref = db.collection('researchers')
        ref.get()
        .then(snap=>{
            snap.forEach(doc=>{
                var researcherEmail = doc.data().email
                var researcherName = doc.data().name[0]+' '+doc.data().name[1]
                var researcherRank = doc.data().status?doc.data().status:'Bronze'
                this.all_researcher_basic_info.push(doc.data())
 
                let ref_tcpre = db.collection('ticket_completed').where('hand_in_month','==',previousMonthYear)
                ref_tcpre.where('submitted_by', '==', doc.data().email).where('pay_for_ticket','==',true).orderBy("ticket_number", "desc")
                .get()
                .then(snap=>{
                    snap.forEach(ticket=>{
                        self.all_researcher_completed_tickets_previousMonth.push({
                            'researcherName':researcherName,
                            'researcherEmail':researcherEmail,
                            'ticketId':ticket.data().ticket_number,
                            'price':ticket.data().price,
                            'rank':researcherRank
                        })
                    })
                })
                let ref_tc = db.collection('ticket_completed').where('hand_in_month','==',currentMonthYear)
                ref_tc.where('submitted_by', '==', doc.data().email).where('pay_for_ticket','==',true)
                .get()
                .then(snap=>{
                    snap.forEach(ticket=>{
                        self.all_researcher_completed_tickets.push({
                            'researcherName':researcherName,
                            'researcherEmail':researcherEmail,
                            'ticketId':ticket.data().ticket_number,
                            'price':ticket.data().price,
                            'rank':researcherRank
                        })
                    })
                })
                let ref_te = db.collection('ticket_editing').where('in_editing_month','==',currentMonthYear)
                ref_te.where('researcher_in_charge', '==', doc.data().email).where('submitted', '==', false)
                .get()
                .then(snap=>{
                    snap.forEach(ticket=>{
                        self.all_researcher_editing_tickets.push({
                            'researcherName':researcherName,
                            'researcherEmail':researcherEmail,
                            'ticketId':ticket.data().ticket_number,
                        })
                    })
                })
            })
        })
        .catch(err=>{
            console.log("error on loading all researchers")
            console.log(err)
        })
    },
}
</script>